var _excluded = ["original"];

var _romanizers;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { LocaleCode } from '@tablecheck/locales';
import './utils/lang/index.js';
import { Japanese } from './utils/lang/Japanese.js';
import { Korean } from './utils/lang/Korean.js';
import { English } from './utils/lang/English.js';
var shouldIncludeLastName = [LocaleCode.Korean];
var romanizers = (_romanizers = {}, _defineProperty(_romanizers, LocaleCode.Japanese, new Japanese()), _defineProperty(_romanizers, LocaleCode.Korean, new Korean()), _defineProperty(_romanizers, LocaleCode.English, new English()), _romanizers);

var Name = /*#__PURE__*/function () {
  function Name(_ref) {
    var firstName = _ref.firstName,
        lastName = _ref.lastName,
        locale = _ref.locale,
        kanjiLastName = _ref.kanjiLastName,
        kanjiFirstName = _ref.kanjiFirstName;

    _classCallCheck(this, Name);

    _defineProperty(this, "firstName", void 0);

    _defineProperty(this, "lastName", void 0);

    _defineProperty(this, "kanjiFirstName", void 0);

    _defineProperty(this, "kanjiLastName", void 0);

    _defineProperty(this, "locale", void 0);

    _defineProperty(this, "romanizer", void 0);

    this.firstName = firstName || '';
    this.lastName = lastName || '';
    this.kanjiFirstName = kanjiFirstName || '';
    this.kanjiLastName = kanjiLastName || '';
    this.locale = locale || LocaleCode.English;
    this.romanizer = this._findRomanizer(locale || LocaleCode.English);
  } // eslint-disable-next-line class-methods-use-this


  _createClass(Name, [{
    key: "_findRomanizer",
    value: function _findRomanizer(locale) {
      if (!locale) return;
      return romanizers[locale];
    }
  }, {
    key: "_romanizeName",
    value: function _romanizeName() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var opts = arguments.length > 1 ? arguments[1] : undefined;

      if (name) {
        // ([^\u00C0-\u017F]\b\w) : avoids accented characters within the words
        // (^.) : captures very first character of the name
        // (\W[\u00C0-\u017F]\b) : captures accented characters, if present at word boundaries
        var accentedCharsRegex = /([^\u00C0-\u017F]\b\w)|(^.)|(\W[\u00C0-\u017F]\b)/g;

        var romanizer = this._findRomanizer(opts === null || opts === void 0 ? void 0 : opts.target);

        if (romanizer || !(opts !== null && opts !== void 0 && opts.target)) {
          return ((romanizer === null || romanizer === void 0 ? void 0 : romanizer.transliterateName(name, opts === null || opts === void 0 ? void 0 : opts.isLastName)) || name).replace(accentedCharsRegex, function (match) {
            return match.toUpperCase();
          });
        }
      }

      return '';
    }
  }, {
    key: "_getNameTranslations",
    value: function _getNameTranslations(name, isLastName) {
      var _this = this;

      var result = Object.values(LocaleCode).reduce(function (a, c) {
        if (!name) return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, c, ''));

        var romanizedName = _this._romanizeName(name, _objectSpread({
          target: c
        }, shouldIncludeLastName.includes(c) ? {
          isLastName: isLastName
        } : {}));

        if (romanizedName) return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, c, romanizedName));
        return _objectSpread({}, a);
      }, {});
      return result;
    }
  }, {
    key: "_translate",
    value: function _translate(name, isLastName) {
      return _objectSpread(_objectSpread({}, this._getNameTranslations(name, isLastName)), {}, {
        original: name || ''
      });
    }
  }, {
    key: "_firstNameTranslations",
    value: function _firstNameTranslations() {
      return this._translate(this.firstName);
    }
  }, {
    key: "_lastNameTranslations",
    value: function _lastNameTranslations() {
      return this._translate(this.lastName, true);
    }
  }, {
    key: "_localize",
    value: function _localize(name, locale) {
      var romanizer = this._findRomanizer(locale);

      if (romanizer && romanizer.isNative(name.original)) return name.original;
      var keys = Object.keys(function (_ref2) {
        var original = _ref2.original,
            o = _objectWithoutProperties(_ref2, _excluded);

        return o;
      }(name));

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];
        var value = name[key];
        if (value !== null && value !== void 0 && value.localeCompare(name.original, locale, {
          sensitivity: 'accent'
        })) return value;
      }

      return name.original;
    }
  }, {
    key: "_localizeFullName",
    value: function _localizeFullName(firstName, lastName) {
      var _this$romanizer, _this$romanizer2;

      var isFirstLastFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var fullName = [((_this$romanizer = this.romanizer) === null || _this$romanizer === void 0 ? void 0 : _this$romanizer.formatName(firstName)) || firstName, ((_this$romanizer2 = this.romanizer) === null || _this$romanizer2 === void 0 ? void 0 : _this$romanizer2.formatName(lastName)) || lastName];
      return (isFirstLastFormat ? fullName : fullName.reverse()).filter(function (n) {
        return n;
      }).join(' ');
    }
  }, {
    key: "setLocale",
    value: function setLocale(locale) {
      this.locale = locale;
      this.romanizer = this._findRomanizer(locale);
    }
  }, {
    key: "queryFirstName",
    value: function queryFirstName() {
      var _this$romanizer3, _this$romanizer4;

      var firstNameTranslations = this._firstNameTranslations();

      var original = ((_this$romanizer3 = this.romanizer) === null || _this$romanizer3 === void 0 ? void 0 : _this$romanizer3.normalizeForQuery(firstNameTranslations.original)) || firstNameTranslations.original;
      var romanizedName = ((_this$romanizer4 = this.romanizer) === null || _this$romanizer4 === void 0 ? void 0 : _this$romanizer4.normalizeForQuery(this._localize(firstNameTranslations, LocaleCode.English))) || '';
      return "".concat(original, " ").concat(romanizedName);
    }
  }, {
    key: "queryLastName",
    value: function queryLastName() {
      var _this$romanizer5, _this$romanizer6;

      var lastNameTranslations = this._lastNameTranslations();

      var original = ((_this$romanizer5 = this.romanizer) === null || _this$romanizer5 === void 0 ? void 0 : _this$romanizer5.normalizeForQuery(lastNameTranslations.original)) || lastNameTranslations.original;
      var romanizedName = ((_this$romanizer6 = this.romanizer) === null || _this$romanizer6 === void 0 ? void 0 : _this$romanizer6.normalizeForQuery(this._localize(lastNameTranslations, LocaleCode.English))) || '';
      return "".concat(original, " ").concat(romanizedName);
    }
  }, {
    key: "localizeFirstName",
    value: function localizeFirstName() {
      return this._localize(this._firstNameTranslations(), this.locale);
    }
  }, {
    key: "localizeLastName",
    value: function localizeLastName() {
      return this._localize(this._lastNameTranslations(), this.locale);
    }
  }, {
    key: "getFullName",
    value: function getFullName() {
      var isFirstLastFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
      var name = [this.localizeFirstName(), this.localizeLastName()];
      if (typeof isFirstLastFormat === 'boolean') return (isFirstLastFormat ? name : name.reverse()).join(separator);
      return isFirstLastFormat(this.localizeFirstName(), this.localizeLastName());
    }
  }, {
    key: "sortValue",
    value: function sortValue() {
      var isFirstLastFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var fullName = this._localizeFullName(this.localizeFirstName(), this.localizeLastName(), isFirstLastFormat);

      var highestSortValue = String.fromCharCode(65535); // `No customer` and `walkin` should have a bigger value than any other names on sort
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/charCodeAt

      if (!fullName) return highestSortValue;
      return fullName;
    }
  }, {
    key: "ts1SortValue",
    value: function ts1SortValue() {
      var fullName = this._localizeFullName(this.firstName, this.lastName);

      return fullName || '';
    }
  }, {
    key: "shouldShowNameFurigana",
    value: function shouldShowNameFurigana() {
      return this.shouldShowLastNameFurigana() || this.shouldShowFirstNameFurigana();
    }
  }, {
    key: "shouldShowLastNameFurigana",
    value: function shouldShowLastNameFurigana() {
      var kanjiLastName = this.kanjiLastName;
      var localizedLastName = this.localizeLastName();
      return !!(kanjiLastName && localizedLastName && localizedLastName !== kanjiLastName);
    }
  }, {
    key: "shouldShowFirstNameFurigana",
    value: function shouldShowFirstNameFurigana() {
      var kanjiFirstName = this.kanjiFirstName;
      var localizedFirstName = this.localizeFirstName();
      return !!(kanjiFirstName && localizedFirstName && kanjiFirstName !== localizedFirstName);
    }
  }]);

  return Name;
}();

export { Name };
